/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.categories.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.helpers',
  'acme.common.factory.notice',
  'acme.view.application.coupons.categories.create.selectCouponsModal.controllers',
  'acme.view.application.coupons.categories.create.removeCouponModal.controllers'
])

.controller('CouponsCategoriesCreateController', ['$scope', '$q', '$state', '$uibModal', 'ApiService', 'PermissionsService', 'NoticeFactory', 'HelpersService', function($scope, $q, $state, $uibModal, ApiService, PermissionsService, NoticeFactory, HelpersService) {

    $scope.couponsCategoriesCreate = {

      model: {},

      coupons: [],

      savedCoupons: [],

      couponsList: [],

      isLoaded: false,

      notice: new NoticeFactory(),

      grid: {
        pageSize: 50,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        showFooter: true,
        columns: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'name',
            displayName: 'name'
          },
          {
            field: 'code',
            displayName: 'code'
          },
          {
            field: 'description',
            displayName: 'description'
          }
        ]
      },

      init: function() {
        title = {
          title: 'Edit Category',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.coupons.categories');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            permissions: ['COUPON_CATEGORIES_UPDATE'],
            action: function() {
              $scope.couponsCategoriesCreate.update(true);
            }
          }
        };

        $scope.$emit('Application::contentTitleChange', title);

        if($state.params && $state.params.id){
          ApiService.coupons.categories.detail($state.params.id).then(this.success.detail, this.error.detail);
        }

        if (PermissionsService.check('COUPONS_UPDATE')) {
          $scope.couponsCategoriesCreate.grid.columns.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.couponsCategoriesCreate.removeCoupon(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row, $index)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>'
          });
        }
      },

      checkPermissions: function(permission){
        return PermissionsService.check(permission);
      },

      filterUsed: function() {
        var i, ii, self=$scope.couponsCategoriesCreate,
          usedCoupons = self.coupons.map( function(coupon) {
            return coupon.id;
          }),
          unUsedCoupons = [];
        for(i=0, ii=self.couponsList.length; i < ii; i++){
          if(usedCoupons.indexOf(self.couponsList[i].id) < 0){
            unUsedCoupons.push(self.couponsList[i]);
          }
        }
        return unUsedCoupons;
      },

      getCoupons: function() {
        ApiService.coupons.getCouponsByCategory($scope.couponsCategoriesCreate.model.id, HelpersService.getPaginator()).then($scope.couponsCategoriesCreate.success.getCoupons, $scope.couponsCategoriesCreate.error.getCoupons);
      },

      getAllCoupons: function() {
        ApiService.coupons.list(HelpersService.getPaginator()).then($scope.couponsCategoriesCreate.success.getAllCoupons, $scope.couponsCategoriesCreate.error.getAllCoupons);
      },

      findCoupon: function(couponId, list) {
        var self = $scope.couponsCategoriesCreate, i, ii, r;
        for(i=0, ii=list.length; i < ii; i++){
          if(list[i].id === couponId) {
            r = {
              index: i,
              coupon: list[i]
            };
            break;
          }
        }
        return r;
      },

      removeCoupon: function(row) {
        var self = $scope.couponsCategoriesCreate;

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/coupons/categories/create/modals/removeCouponModal.tpl.html',
          size: 'lg',
          controller: 'RemoveCouponModalController',
          resolve: {
            couponName: function() {
              return row.entity.name;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          var i, ii,
            couponId = row.entity.id,
            savedCoupon = self.findCoupon(couponId, self.savedCoupons),
            coupon = self.findCoupon(couponId, self.coupons);
          if(savedCoupon) {
            savedCoupon.coupon.markedForDeletion = true;
          }
          self.coupons.splice(coupon.index, 1);
        }, function () {
          // Do nothing
        });
      },

      addCoupons: function(){
        var self = $scope.couponsCategoriesCreate;
        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/coupons/categories/create/modals/selectCouponsModal.tpl.html',
          size: 'lg',
          controller: 'SelectCouponsModalController',
          resolve: {
            coupons: function() {
              return self.filterUsed();
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (selectedCoupons) {
          var i, ii, savedCoupon;
          for (i=0, ii=selectedCoupons.length;i < ii; i++) {
            savedCoupon = self.findCoupon(selectedCoupons[i].id, self.savedCoupons);
            if(savedCoupon) {
              savedCoupon.coupon.markedForDeletion = false;
            }else {
              self.savedCoupons.push(selectedCoupons[i]);
            }
            self.coupons.push(selectedCoupons[i]);
          }
        }, function () {
          // Do nothing
        });
      },

      update: function() {
        var self = $scope.couponsCategoriesCreate, props = {
          id: self.model.id,
          name: self.model.name,
          description: self.model.description
        };
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();
        ApiService.coupons.categories.update(props).then(self.success.update, self.error.update);
      },

      updateCoupons: function() {
        var self = $scope.couponsCategoriesCreate, savedCoupons = self.savedCoupons || [], updatePromises;
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();
        updatePromises = savedCoupons.map(function(coupon) {
          var props = {
            id: coupon.id,
            code: coupon.code,
            name: coupon.name,
            description: coupon.description,
            programName: coupon.programName,
            companyName: coupon.companyName,
            resellerId: coupon.resellerId,
            categoryId: self.model.id
          };

          if(coupon.markedForDeletion){
            props.categoryId = '';
          }
          return ApiService.coupons.update(props);
        });

        $q.all(updatePromises).then( self.success.updateCoupons, self.error.updateCoupons);
      },

      success: {
        init: function(response) {},

        detail: function(response) {
          $scope.couponsCategoriesCreate.model = response.data.payload;
          $scope.couponsCategoriesCreate.getCoupons();
          $scope.couponsCategoriesCreate.getAllCoupons();
        },

        getCoupons: function(response) {
          $scope.couponsCategoriesCreate.coupons = response.data.payload.list;
          $scope.couponsCategoriesCreate.savedCoupons = angular.copy(response.data.payload.list);
          $scope.couponsCategoriesCreate.isLoaded = true;
        },

        getAllCoupons: function(response) {
          $scope.couponsCategoriesCreate.couponsList = response.data.payload.list;
        },

        updateCoupons: function(response) {
          $state.go('application.coupons.categories');
        },

        update: function(response) {
          $scope.couponsCategoriesCreate.updateCoupons();
        }
      },

      error: {
        init: function(response) {},

        detail: function(response) {},

        getCoupons: function(response) {
          $scope.couponsCategoriesCreate.coupons = [];
          $scope.couponsCategoriesCreate.isLoaded = true;
        },

        updateCoupons: function(response) {
          $scope.couponsCategoriesCreate.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        },

        update: function(response) {
          $scope.couponsCategoriesCreate.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        }
      }

    };

    $scope.couponsCategoriesCreate.init();

}]);